module.exports = __webpack_public_path__ + "static/media/Gilroy-Light.53ab1126.eot";